<div>
	<div class="top-buttons">
		<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>
	</div>

	<app-setup-wizard-client-form
		[edit]="client()"
		[loading]="loading()"
		(onSubmit)="onFormSubmit($event)"
	></app-setup-wizard-client-form>
</div>
